import React, { Fragment } from 'react'
import {
    List, Datagrid, Filter, ShowButton, UrlField, Button, TextInput, TextField, EditButton, BulkDeleteButton, FunctionField, DeleteButton, useRecordContext, Link,
    ChipField
} from 'react-admin'
import { InfluencerStatusSelectInput, SBOCareCategorySelectInput } from '../../UI/Input/SelectInput'
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'

const ListFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <InfluencerStatusSelectInput label="Status" source="status" alwaysOn />
        <SBOCareCategorySelectInput label="category" source="category" alwaysOn />
    </Filter>
)
const ListActionButtons = ({ ...props }) => {
    return (<>
        <BulkDeleteButton {...props} undoable={false}
            confirmTitle="Delete File Record"
            confirmContent={"Are you sure you want to delete this record?"} />
    </>)
}
const ProfileidFiled = (props) => {
    const record = useRecordContext();
    return (
        <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event) => event.stopPropagation()} />
    )
}


const RaiseTicketList = ({ ...props }) => {

    return (
        <List {...props} title="Raise Ticket" bulkActionButtons={<ListActionButtons />} filters={<ListFilter />} sort={{ field: 'title', order: 'ASC' }}>

            <Datagrid >
                <ProfileidFiled source="profile_id" label="Profile Id" />
                <TextField source='created_at' label="Created At" />
                <ChipField source='total_tickets' label="Total Tickets" />
                <TextField source="title" label="Title" />
                <TextField source="commends" label="Approve Commends" />
                <TextField source="decline_reason" label="Decline Reason" />
                <FunctionField source="status" label="Status" render={record => {
                    if (record['status'] === 'Reject') {
                        return (<span style={{ color: 'red' }}>Reject</span>)
                    } else if (record['status'] === 'Pending') {
                        return (<span style={{ color: 'orange' }}>Pending</span>)
                    } else {
                        return (<span style={{ color: 'green' }}>Approved</span>)
                    }
                }} />
                <FunctionField source="proof" label="Proof" render={record => {
                    if (record['proof_full_url']) {
                        return (<img style={{ maxWidth: '100px' }} src={record['proof_full_url']} />)
                    }
                }} />
                <TextField source='description' label="Description" />
                <TextField source="approvedby.name" label="Approved By" />
                <TextField source="rejactedby.name" label="Rejacted By" />
                <TextField source="approvedDate" label="Approved Date" />
                <TextField source="rejectedDate" label="Rejected Date" />



                {useCheckPermissions('SboCare_Edit') ? <FunctionField source="status" label="Edit Action" render={record => {

                    return (<EditButton />)


                }} /> : null}
                {useCheckPermissions('SboCare_View') ? <ShowButton /> : null}

            </Datagrid>

        </List>
    )
}


export default RaiseTicketList